import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { getTopics, getLastTopics } from "@store/action/smartend/FilterAction";
import { useSelector } from "react-redux";
import { useRouteMatch } from "react-router-dom";
import { FcCalendar } from "react-icons/fc";
import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  FacebookIcon,
  EmailShareButton,
  EmailIcon,
  TwitterIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";
import { useForm } from "react-hook-form";
import FollowUs from "../FollowUs";

const FilterBlog = ({ t, dispatch, setCurrentPage }) => {
  const store = useSelector((state) => state.FilterReducer);
  const webmasterTitle = useRouteMatch().params.webmasterTitle;
  const params = { order: "visits", dir: "desc", limit: 4 };
  const params2 = { number: 3 };
  const topics = store?.data.data;
  const LastTopics = store?.LastTopics;
  const lang = localStorage.getItem("lang") || "en";
  const lang1 = lang.substring(1, lang.length - 1) || "en";
  const [search, setSearch] = useState("");

  const renderTopTopics = () => {
    return topics?.map((item, i) => {
      return (
        <li key={i}>
          <Link to={`/dataNews/${webmasterTitle}/topics/${item.id}`}>
            <h5 style={{ width: "200px" }} className="text-truncate">
              {item?.title}
            </h5>
          </Link>
          <div className="suggest-comment">
            <i className="fa fa-eye"></i>
            <p> {item?.visits}</p>
          </div>
        </li>
      );
    });
  };
  const renderRecentPostTopics = () => {
    if (LastTopics?.length) {
      return LastTopics?.map((item, i) => {
        return (
          <li
            key={i}
            style={{
              paddingBottom: "0",
              marginBottom: "15px",
              borderBottom: "0",
            }}
          >
            <div className="suggest-img">
              <Link to={`/dataNews/${webmasterTitle}/topics/${item.id}`}>
                <img
                  width="70px"
                  height="60px"
                  src={
                    item?.photo_file
                      ? item.photo_file
                      : "https://t3.ftcdn.net/jpg/02/48/42/64/360_F_248426448_NVKLywWqArG2ADUxDq6QprtIzsF82dMF.jpg"
                  }
                  alt="topic"
                />
              </Link>
            </div>
            <div className="suggest-content">
              <div className="suggest-title">
                <h4 style={{ width: "200px" }} className="text-truncate">
                  {item?.title}
                </h4>
              </div>
              <div className="suggest-meta">
                <div className="suggest-date">
                  <FcCalendar />
                  <p>
                    {new Date(item?.date).toLocaleString(`${lang1}-US`, {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </p>
                </div>
                <div className="suggest-comment">
                  <i className="fa fa-comments"></i>
                  <p>{item?.commentsCount}</p>
                </div>
              </div>
            </div>
          </li>
        );
      });
    }
  };
  const history = useHistory();
  const { handleSubmit } = useForm();
  const onSubmit = () => {
    setCurrentPage(1);
    history.push(`/dataNews/${webmasterTitle}/topics?search=${search}`);
  };

  useEffect(() => {
    dispatch(getTopics(webmasterTitle, params));
    dispatch(getLastTopics(webmasterTitle, params2));
  }, [webmasterTitle]);

  return (
    <div className="col-lg-3">
      <div className="row">
        <div className="col-lg-12">
          <form className="blog-src" onSubmit={handleSubmit(onSubmit)}>
            <input
              type="text"
              placeholder={t("Search...")}
              onChange={(e) => setSearch(e.target.value)}
              value={search}
            />
            <button>
              <i className="fa fa-search"></i>
            </button>
          </form>
        </div>
        <div className="col-md-7 col-lg-12">
          <div className="blog-filter">
            <h3>{t("Recent post")}</h3>
            <ul className="blog-suggest">{renderRecentPostTopics()}</ul>
          </div>
        </div>
        <div className="col-md-5 col-lg-12">
          <div className="blog-filter">
            <h3>{t("Top Post")}</h3>
            <ul className="blog-cate">{renderTopTopics()}</ul>
          </div>
        </div>
        <FollowUs />
      </div>
    </div>
  );
};

export default FilterBlog;
